import React from 'react'
import { FieldArray, Field } from 'formik'
import { Columns, Button, Icon } from 'react-bulma-components'
import InputField from '../../form/fields/input'
import { RemoveIcon } from '../../icons'
import { ValuesInTimeSectionProps } from './types'
import { dateToDateInputValue } from '../../../utils/date'

/**
 * Component that handles the valuesInTime FieldArray section
 * Manages adding, removing, and displaying time periods
 */
const ValuesInTimeSection: React.FC<ValuesInTimeSectionProps> = ({ values }) => {
  return (
    <Columns>
      <FieldArray name="valuesInTime">
        {({ push, remove }) => (
          <Columns.Column size={12}>
            {values.map((_, index) => (
              <Columns key={index}>
                <Columns.Column size={3}>
                  <Field
                    label="Valeur"
                    name={`valuesInTime.${index}.value`}
                    component={InputField}
                    type="number"
                    required
                  />
                </Columns.Column>
                <Columns.Column size={4}>
                  <Field
                    label="Date de début"
                    name={`valuesInTime.${index}.effectiveFrom`}
                    component={InputField}
                    type="date"
                    required
                  />
                </Columns.Column>
                <Columns.Column size={4}>
                  <Field
                    label={`Date de fin ${index === values.length - 1 ? '(optionnel)' : ''}`}
                    name={`valuesInTime.${index}.effectiveTo`}
                    component={InputField}
                    type="date"
                  />
                </Columns.Column>
                <Columns.Column size={1}>
                  {values.length > 1 && (
                    <Button
                      color="danger"
                      size="small"
                      onClick={() => remove(index)}
                      style={{ marginTop: '2.2rem' }}
                    >
                      <Icon>
                        <RemoveIcon color="white" />
                      </Icon>
                    </Button>
                  )}
                </Columns.Column>
              </Columns>
            ))}
            <Button
              onClick={() =>
                push({
                  value: '',
                  effectiveFrom: dateToDateInputValue(new Date()),
                  effectiveTo: '',
                })
              }
            >
              Ajouter une période
            </Button>
          </Columns.Column>
        )}
      </FieldArray>
    </Columns>
  )
}

export default ValuesInTimeSection
